import React, { useState } from 'react';
import './MonthYearInput.scss';

const MonthYearInput = ({
  name, value = '', onChange, label, intl, required = true, ...props
}) => {
  const [error, setError] = useState('');

  // Always make sure value is a string
  const safeValue = value || '';

  const validate = (numbers) => {
    if (!numbers) {
      return required ? 'Expiry date is required' : '';
    }

    if (numbers.length < 4) {
      return 'Please enter a valid expiry date';
    }

    const month = parseInt(numbers.slice(0, 2), 10);
    const year = parseInt(numbers.slice(2, 4), 10);

    const now = new Date();
    const currentYear = now.getFullYear() % 100;
    const currentMonth = now.getMonth() + 1;

    if (
      year < currentYear
            || (year === currentYear && month < currentMonth)
    ) {
      return 'Card has expired';
    }

    return '';
  };

  const handleChange = (event) => {
    let numbers = event.target.value
      .replace(/\D/g, '')
      .slice(0, 4);

    // Validate month
    if (numbers.length >= 2) {
      const monthNumber = parseInt(numbers.slice(0, 2), 10);

      if (monthNumber === 0) {
        numbers = `01${numbers.slice(2)}`;
      } else if (monthNumber > 12) {
        numbers = `12${numbers.slice(2)}`;
      }
    }

    const month = numbers.slice(0, 2);
    const year = numbers.slice(2, 4);

    // Automatically add "/"
    const formattedValue = numbers.length > 2
      ? `${month}/${year}`
      : numbers;

    // Validate only when complete
    const validationError = numbers.length === 4 ? validate(numbers) : '';

    setError(validationError);

    onChange({
      name,
      month,
      year,
      value: formattedValue,
      error: validationError,
    });
  };

  const handleBlur = () => {
    const numbers = safeValue.replace(/\D/g, '');

    const validationError = validate(numbers);

    setError(validationError);
  };

  return (
    <div className="monthYearInput">
      <label htmlFor={name}>{label}</label>
      <input
        {...props}
        name={name}
        value={value}
        placeholder="MM/YY"
        maxLength={5}
        onChange={handleChange}
        onBlur={handleBlur}
      />

      {error && (
        <div style={{ color: 'red', marginTop: '4px' }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default MonthYearInput;
